import type { Gradient } from '@jouzen/ecom-components/v3/RadialGradient';

const landingPageBodyGradients: Gradient[] = [
  {
    shape: 'circle',
    hex: '#FEFCF9',
    id: 'off-white-1',
    position: [35, 30],
    opacity: 1,
    size: 15,
  },
  {
    shape: 'circle',
    hex: '#FFFFFF',
    id: 'white-1',
    position: [5, 50],
    opacity: 1,
    size: 10,
  },

  {
    shape: 'circle',
    hex: '#DCCFBB',
    id: 'beige-1',
    position: [75, 30],
    opacity: 1,
    size: 15,
  },
  {
    shape: 'circle',
    hex: '#E4DED4',
    id: 'beige-2',
    position: [82, 35],
    opacity: 1,
    size: 10,
  },
  {
    shape: 'circle',
    hex: '#FEFAEF',
    id: 'beige-3',
    position: [2, 35],
    opacity: 1,
    size: 8,
  },
  {
    shape: 'circle',
    hex: '#D9D3C3',
    id: 'beige-4',
    position: [85, 63],
    opacity: 1,
    size: 10,
  },
  {
    shape: 'ellipse',
    hex: '#FBF7ED',
    id: 'beige-5',
    position: [1, 50],
    opacity: 1,
    size: 10,
  },
  {
    shape: 'circle',
    hex: '#FFFFFF',
    id: 'white-2',
    position: [65, 68],
    opacity: 1,
    size: 10,
  },
  {
    shape: 'circle',
    hex: '#FFFFFF',
    id: 'white-3',
    position: [46, 62],
    opacity: 1,
    size: 10,
  },
];

export default landingPageBodyGradients;
